export default __webpack_public_path__ + "files/ab8aa80cba445eb0fb75e6611c292567.png";